
import {fetchAnchorValue } from './../../common/utils';

Tag.version = 1000;

Tag.lang = 'en';
Tag.langs = [
    'en'
];
Tag.setLang = (lang: any) => {
    Tag.lang = lang;
}

Object.defineProperty(Tag, 'name', {
    writable: true,
    value: 'Tag'
});


function Tag(props: any) {

    const { anchorLinksValue } = props;

    return (
        <div className="tags-wrap">
            {(props.tagsData && props.tagsData.length > 0) ? (
                <h5 className="tags-heading editable" id="tagsHeading">Tags:</h5>
            ) : null}
            <ul className="tag-lists" id="tag-lists">
                {props.tagsData && props.tagsData.length > 0 &&
                    props.tagsData.map((tagData: any) => {
                        let displayName;
                        if (tagData.keywordseo !== "-" && tagData.keywordseo.trim().length > 0) {
                            displayName = tagData.keywordseo;
                        } else {
                            displayName = tagData.name;
                        }

                        return (
                            <li key={tagData.id}>
                                {tagData.source === 'TOPIC' ? (
                                    <a href={"/topics/" + displayName} target={fetchAnchorValue(anchorLinksValue, "/topics/" + displayName)}>{tagData.name}</a>
                                ) : (
                                    tagData.name
                                )}
                            </li>
                        );
                    })}
            </ul>
        </div>
    );
}

export default Tag;

